import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.5 6.1L8.35 8.4125L8.55 8.95L9.0875 9.15L11.3875 10L9.0875 10.85L8.55 11.05L8.35 11.5875L7.5 13.9L6.65 11.5875L6.45 11.05L5.9125 10.85L3.6125 10L5.9125 9.15L6.45 8.95L6.65 8.4125L7.5 6.1ZM7.5 2.5L5.475 7.975L0 10L5.475 12.025L7.5 17.5L9.525 12.025L15 10L9.525 7.975L7.5 2.5Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.75 0L14.7625 2.7375L17.5 3.75L14.7625 4.7625L13.75 7.5L12.7375 4.7625L10 3.75L12.7375 2.7375L13.75 0Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }